export default "__VITE_ASSET__qV$sAxnB__"